module.exports = __webpack_public_path__ + "static/media/Group.e4809e28.svg";